<template>
    <b-row>
        <PhotoWidget ref="PhotoWidget"></PhotoWidget>
        <ImageLightBox ref="ImageLightBox"></ImageLightBox>
        <GenericPopups ref="GenericPopups"></GenericPopups>
        <b-col cols="9">
            <b-row>
                <b-col class="workspace-header">
                    <h1 class="text-right"><i class="fa-duotone fa-box-full fa-fw"></i> Appraisal</h1>
                </b-col>
            </b-row>

            <b-modal id="modal-1" title="Manually Receive Kit" header-bg-variant="secondary">
                <p class="my-4">Hello from modal!</p>
            </b-modal>

            <b-row>
                <b-col>
                    <transition appear name="fade" mode="out-in">
                        <router-view></router-view>
                    </transition>
                </b-col>
            </b-row>
        </b-col>

        <b-col cols="3">
            <b-row>
                <b-col>

                    <dashboard-side-data-widget label="Previous Day(s) Outstanding"
                                                :data="dashboardData.previousOutstanding"
                                                icon="fa-light fa-circle-exclamation">
                    </dashboard-side-data-widget>
                    
                    <dashboard-side-data-widget label="Orders Received"
                                                :data="dashboardData.totalKitsReceived"
                                                icon="fa-light fa-pallet-alt">
                    </dashboard-side-data-widget>

                    <dashboard-side-data-widget label="Total Orders Appraised"
                                                :data="dashboardData.totalOrdersAppraised"
                                                icon="fa-light fa-box-full">
                    </dashboard-side-data-widget>

                    <dashboard-side-data-widget label="My Orders Appraised"
                                                :data="dashboardData.myOrdersAppraised"
                                                icon="fa-light fa-hand-holding-box">
                    </dashboard-side-data-widget>

                    <template v-if="state === 'appraisals-appraise'">
                        <dashboard-side-data-widget label="Total Appraised Items"
                                                    :data="dashboardData.totalItemsAppraised"
                                                    icon="fa-light fa-rings-wedding">
                        </dashboard-side-data-widget>


                        <template>
                            <div>
                                <b-table class="my-3 appraisal-summary-table"
                                         outlined
                                         small
                                         striped
                                         sticky-header="668px"
                                         :busy.sync="inventoryListSummaryLoading"
                                         head-variant="dark"
                                         table-variant="light"
                                         :items="inventoryListSummary"
                                         :fields="['picture', 'details', {key: 'weight', label: ''}, {key: 'options', label: ''}]"
                                         tbody-class="body_area"
                                         :tbody-tr-class="holdItemRowClass">

                                    <template v-slot:cell(picture)="data">
                                        <div class="text-center">

                                            <div class="pic position-relative pointer" @click="openLightBox(data.item.media)">
                                                <b-badge pill v-if="data.item.media.length > 1" variant="primary" class="position-absolute text-white m-1">
                                                    <i class="fa-solid fa-images "></i> {{ data.item.media.length }}
                                                </b-badge>
                                                <img width="60px" :src="data.item.media[0] ? data.item.media[0].url : 'https://via.placeholder.com/40' " />
                                            </div>
                                            
                                        <div class="font-xxs">ID: {{ data.item.id }}</div>
                                        </div>
                                    </template>
                                    <template v-slot:cell(details)="data">
                                        <div class="font-xxs"><strong>{{ data.item.type.name }}</strong></div>
                                        <div class="font-xxs" v-if="data.item.children[0] && data.item.children[0].style_name">
                                            <template v-if="data.item.type.item_category_id === 2">
                                                {{ data.item.children[0].style_name }}
                                            </template>
                                            <template v-else>
                                                {{ data.item.children[0].style_name | titleCase }}
                                            </template>

                                        </div>
                                        <div class="font-xxs" v-if="data.item.type && data.item.type.item_category_id == 3">Eav: {{ data.item.numismatic_value }}</div>
                                        <div class="font-xxs">Qty:
                                            <span v-if="data.item.type.item_category_id === 2">
                                                {{ data.item.children[0].quantity }} Coins/Bullion
                                            </span>
                                            <span v-else>
                                                {{ data.item.quantity }}
                                            </span>
                                        </div>
                                        <div class="font-xxs" v-if="data.item.brand_name">Brand: {{ data.item.brand_name }}</div>
                                        <template v-if="getChildren(data).length > 0 ">
                                            <div>
                                                <a class="pointer text-primary font-xxs"
                                                   @click="data.toggleDetails"><small>
                                                    <i class="fa-solid text-success"
                                                       :class="data.detailsShowing ? 'fa-minus-circle': 'fa-plus-circle' "></i>
                                                    {{ data.detailsShowing ? 'Hide' : 'Show' }}
                                                    {{ data.item.children.length == 1 ? ' Item Details' : ' Sub Items' }}</small></a>
                                            </div>
                                        </template>
                                    </template>

                                    <template v-slot:cell(weight)="data">
                                        <div><small> {{ data.item.aggregate_dwt }} dwt</small></div>
                                        <div><small><strong>{{ data.item.children[0].class.name | titleCase }}</strong>
                                            <span class="font-xxs"
                                                  v-if="data.item.children[0].purity || data.item.children[0].purity_type">:
                                                {{ data.item.children[0].purity}}{{ data.item.children[0].purity_type }}</span>
                                        </small></div>
                                        <template v-if="data.item.status_name === 'hold'">
                                            <small><b>HOLD</b></small>
                                        </template>
                                    </template>


                                    <template v-slot:cell(options)="data">
                                        <b-dropdown boundary="viewport" size="sm" variant="link" toggle-class="text-decoration-none"
                                                    no-caret>
                                            <template v-slot:button-content>
                                                <i class="fa-solid fa-ellipsis-h fa-fw"></i>
                                            </template>
                                            <b-dropdown-item v-on:click="moveToItem(data.item)">
                                                <i class="fa-solid fa-edit fa-fw"></i> Edit
                                            </b-dropdown-item>
                                            <b-dropdown-item v-on:click="deleteInventory(data.item)">
                                                <i class="fa-solid fa-trash fa-fw"></i> Delete
                                            </b-dropdown-item>
                                            <b-dropdown-item v-on:click="printLabel('item', data.item)"><i class="fa-solid fa-print fa-fw"></i> Print Label
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </template>

                                    <template v-slot:row-details="row">
                                        <template v-for="(item, index) in getChildren(row)">
                                            <b-table
                                                small
                                                :key="index"
                                                :fields="getChildFields(item,index)"
                                                :items="[item]">

                                                <template v-slot:head()="data">
                                                    <span class="font-xxs">{{ data.label | titleCase }}</span>
                                                </template>

                                                <template v-slot:cell(clarity_name)="data">
                                                    <span class="font-xxs">{{ data.value }}</span>
                                                </template>

                                                <template v-slot:cell(aggregate_dwt)="data">
                                                    <span class="font-xxs">{{ data.value }}</span>
                                                </template>
                                                <template v-slot:cell(tare_weight)="data">
                                                    <span class="font-xxs">{{ data.value }}</span>
                                                </template>

                                                <template v-slot:cell()="data">
                                                    <span class="font-xxs">{{ data.value | titleCase }}</span>
                                                </template>
                                                <template v-slot:cell(numismatic_value)="data">
                                                    <span class="font-xxs">{{data.value}}</span>
                                                </template>
                                                <template v-slot:cell(purity)="data">
                                                    <span class="font-xxs">{{data.value}}&nbsp;{{item.purity_type}}</span>
                                                </template>
                                                <template v-slot:cell(type_watch_movement_text)="data">
                                                    <span class="font-xxs">Watch Movement</span>
                                                </template>
                                                <template v-slot:cell(type_name_gem)="data">
                                                    <span class="font-xxs">Gem</span>
                                                </template>
                                                <template v-slot:cell(type_name_synthetic)="data">
                                                    <span class="font-xxs">Synthetic Stone</span>
                                                </template>
                                            </b-table>
                                        </template>
                                    </template>

                                    <template v-slot:table-busy>
                                        <LoadingSpinner :busy="inventoryListSummaryLoading"></LoadingSpinner>
                                    </template>
                                </b-table>
                            </div>
                        </template>
                    </template>


                </b-col>
            </b-row>
        </b-col>

    </b-row>
</template>

<script>
import {
    BROADCAST_CONNECTED,
} from '../../store/actions';
import DashboardSideDataWidget from '@/components/DashboardSideDataWidget';
import LoadingSpinner from '@/components/LoadingSpinner';
import order from '@/store/modules/order';
import PhotoWidget from "../../components/PhotoWidget";
import GenericPopups from "../../components/GenericPopups";
import {assign} from 'lodash';
import ImageLightBox from '@/components/ImageLightBox';

export default {
    name: 'appraisals-index',
    title: 'Appraisal',
    components: {GenericPopups, DashboardSideDataWidget, LoadingSpinner,PhotoWidget, ImageLightBox},
    data() {
        return {
            number: 0,
            dashboardData: {
                totalKitsReceived: null,
                totalOrdersAppraised: null,
                previousOutstanding: null,
                myOrdersAppraised: null,
                totalItemsAppraised: null,
            },
            inventoryListSummary: [],
            inventoryListSummaryLoading: false,
            total_appraised: {
                fields: ['picture', 'details', 'weight', 'options'],
                items: [
                    {
                        additional_packaging: null,
                        brand: 'unknown',
                        color: null,
                        condition: null,
                        eav: 1234.54,
                        melt_hold: 'melt',
                        metal: 'silver',
                        purity: null,
                        quantity: 1,
                        style: null,
                        subItems: true,
                        type: 'Necklace',
                        test_methods: {
                            xrf: true,
                            acid: false,
                            magnet: false,
                            hallmark: false,
                            other: false,
                        },
                        weight: 6.00,
                        weight_type: 'dwt'
                    },
                ],
            }

        };
    },
    created() {

    },
    mounted() {
        //this.getInventory();
        this.getDashboardData();

        console.info(String.fromCodePoint(0x1F6F0) + '%c Broadcast Connected:', 'color:yellow;', this.$store.getters.isBroadcastConnected);
        if (! this.$store.getters.isBroadcastConnected) {
            this.$store.subscribe((mutation) => {
                console.log('%cSubscribe mutation ' + mutation.type, 'color:gray;');
                if (mutation.type === BROADCAST_CONNECTED) {
                    console.info(String.fromCodePoint(0x1F504) + '%c Joining via BROADCAST_CONNECTED mutation.', 'color:green;');
                    this.joinBroadcastChannel();
                }
            });
        } else {
            console.info(String.fromCodePoint(0x2757) + '%c Joining via isBroadcastConnected getter.', 'color:teal;');
            this.joinBroadcastChannel();
        }
    },
    beforeDestroy() {
        console.info(String.fromCodePoint(0x1F44B) + ' Leaving App.Appraisal channel from Appraisal/index.vue.');
        this.$echo.leaveChannel('App.Appraisal');
        this.$scale.disconnect();
    },
    beforeRouteUpdate(to, from, next) {
        this.getDashboardData();
        next();
    },
    methods: {
        openLightBox(media) {
            this.$refs.ImageLightBox.showLightBox(media)
        },
        joinBroadcastChannel: function () {
            console.info(String.fromCodePoint(0x1F91D) + ' Joining App.Appraisal channel from Appraisal/index.vue.');
            this.$echo.channel('App.Appraisal')
                .listen('.InventoryWasCreated', (e) => {
                    this.$bvToast.toast('Item saved.');
                })
                .listen('BroadcastDashboardUpdate', (e) => {
                    this.dashboardData = assign(this.dashboardData, e.payload);
                });
            this.$echo.channel('App.User.' + this.$store.getters.getProfile.id)
                .listen('BroadcastDashboardUpdate', (e) => {
                    this.dashboardData = assign(this.dashboardData, e.payload);
                });
        },
        activateImageModal(item){
            if(item.media.length > 0) {
                this.$refs.PhotoWidget.renderImage(item.media[0].url);
            }
        },
        getInventory(order_id) {
            if (this.state === 'appraisals-appraise') {
                if (!order_id) {
                    order_id = this.$route.params.id;
                }
                this.inventoryListSummaryLoading = true;
                this.$http.get('/orders/' + order_id + '/inventory?sort=-created_at')
                    .then(response => {
                        this.inventoryListSummary = response.data.data;
                        this.inventoryListSummaryLoading = false;
                    });
            }
        },
        getDashboardData(){
            let url = this.$route.params.id ? '/dashboards/appraisal/' + this.$route.params.id : '/dashboards/appraisal';
            this.$http.get(url)
                .then(response => {
                    this.dashboardData = assign(this.dashboardData, response.data.data);
                    //TODO include the other two columns
                });
        },
        print_value(value){
            console.log(value);
            return value;
        },
        getChildFields(item,index){
            switch(item.category_id){
                case 3: //watch movement
                    return [
                        {key: 'type_watch_movement_text', label: 'Type'},
                        {key: 'aggregate_dwt', label: 'DWT'},
                    ];
                case 5: //metal children
                    return [
                        {key: 'type_name', label: 'Type'},
                        {key: 'purity', label: 'Purity'},
                        {key: 'aggregate_dwt', label: 'DWT'},
                    ];
                case 9: //gemstone
                    return [
                        {key: 'type_name_gem', label: 'Type'},
                        {key: 'color_name', label: 'Color'},
                        {key: 'aggregate_dwt', label: 'DWT'},
                    ];
                case 8: //synthetic
                    if(item.type) { //known type, it maybe pearl. pearl does not have color.
                        return [
                            {key: 'type_name', label: 'Type'},
                            {key: 'aggregate_dwt', label: 'DWT'}
                        ];
                    }
                    //unknown type of synthetic, guessed to be synthetic stone
                    return [
                        {key: 'type_name_synthetic', label: 'Type'},
                        {key: 'color_name', label: 'Color'},
                        {key: 'aggregate_dwt', label: 'DWT'},
                    ];
                case 11: //package
                case 1: //other
                    return [
                        {key: 'type_name', label: 'Type'},
                        {key: 'aggregate_dwt', label: 'DWT'},
                    ];
                case 13://diamond && melee types
                    if(item.class_id == 8){ //diamond
                        return [
                            {key: 'type_name', label: 'Type'},
                            {key: 'style_name', label: 'Cut'},
                            {key: 'clarity_name', label: 'Clarity'},
                            {key: 'color_name', label: 'Color'},
                            'quantity',
                            {key: 'numismatic_value', label: 'EAV'},
                            {key: 'tare_weight', label: 'Ct'},
                        ];
                    } else { //melee
                        return [
                            {key: 'type_name', label: 'Type'},
                            {key: 'style_name', label: 'Cut'},
                            {key: 'clarity_name', label: 'Clarity'},
                            {key: 'color_name', label: 'Color'},
                            'quantity',
                            {key: 'numismatic_value', label: 'EAV'},
                            {key: 'tare_weight', label: 'Pts'},
                        ];
                    }
                case 7: //gemstones
                    return [
                        {key: 'type_name', label: 'Type'},
                        {key: 'style_name', label: 'Cut'},
                        {key: 'color_name', label: 'Color'},
                        'quantity',
                        {key: 'numismatic_value', label: 'EAV'},
                        {key: 'aggregate_dwt', label: 'DWT'},
                    ];
            }
        },
        getChildren(row){
            switch(row.item.type.item_category_id){
                case 8: //synthetic
                case 9: //gem-stone
                case 13://diamond
                    return row.item.children;
            }
            return row.item.children.slice(1);
        },
        holdItemRowClass(item) {
            if (item && item.status_name === 'hold') {
                return 'table-warning';
            }
        },
        moveToItem(item){
            this.$router.push('/appraisals/appraise/'+this.$route.params.id+'/inventory/'+item.id + this.jsonToQueryString(this.$route.query));
            //TODO, this is a bad fix, -- default behavior is to nagivate to the same page but not reload its data like we need it too.
            //FIXME this same fix is employeed else where, look up 'TODO, this is a bad fix'
            this.$router.go();
        },
        jsonToQueryString(json){
            return '?' +
                Object.keys(json).map(function(key) {
                return encodeURIComponent(key) + '=' +
                    encodeURIComponent(json[key]);
            }).join('&');
        },
        deleteInventory(item){
            this.$refs.GenericPopups.displayDialog =
            {
                title: 'Delete Item?',
                text: 'Are you sure you want to delete this item?',
                okAction: () =>
                {
                    this.$http.delete('/inventory/'+item.id).then((data) => {
                        this.getInventory(this.$route.id);
                        if(this.$route.params.item_id == item.id){
                            this.$router.push('/appraisals/appraise/'+this.$route.params.id + this.jsonToQueryString(this.$route.query));
                            //FIXME this same fix is employeed else where, look up 'TODO, this is a bad fix'
                            this.$router.go();
                        }
                    });
                },
                ok: 'Delete',
            };
        },
        printLabel(type, item) {
            item.order = this.$store.getters.activeOrder;
            item.customer = this.$store.getters.activeOrder.customer;
            this.$label(type, item);
        },
    },
    computed: {
        state: function () {
            return this.$route.name;
        },
    },
};

</script>

<style scoped>
    .body_area{
        height: 3000px !important;
        color:blue !important;
    }
    .appraisal-summary-table small,
    .appraisal-summary-table .small,
    .appraisal-summary-table .font-xxs {
        font-size: .7rem !important;
    }
</style>
